<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="submitId" >
        <span slot="label" >
          <a-tooltip>
            提交ID，外键 task_submit.id<template slot="title">提交ID，外键 task_submit.id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.submitId"  :placeholder="$t('请输入')+'提交ID，外键 task_submit.id'" />
      </a-form-model-item>
      <a-form-model-item prop="taskId" >
        <span slot="label" >
          <a-tooltip>
            任务ID，冗余便于查询<template slot="title">任务ID，冗余便于查询</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.taskId"  :placeholder="$t('请输入')+'任务ID，冗余便于查询'" />
      </a-form-model-item>
      <a-form-model-item prop="orderId" >
        <span slot="label" >
          <a-tooltip>
            订单ID，外键订单表<template slot="title">订单ID，外键订单表</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderId"  :placeholder="$t('请输入')+'订单ID，外键订单表'" />
      </a-form-model-item>
      <a-form-model-item prop="orderNo" >
        <span slot="label" >
          <a-tooltip>
            订单号<template slot="title">订单号</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderNo" :maxLength="100" :placeholder="$t('请输入')+'订单号'" />
      </a-form-model-item>
      <a-form-model-item prop="proofImages" >
        <span slot="label" >
          <a-tooltip>
            该订单的佐证图片(可选)<template slot="title">该订单的佐证图片(可选)</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTaskSubmitOrder, addTaskSubmitOrder, updateTaskSubmitOrder } from '@/api/task/taskSubmitOrder'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        submitId: null,

        taskId: null,

        orderId: null,

        orderNo: null,

        proofImages: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        submitId: [
          { required: true, message: '提交ID，外键 task_submit.id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        taskId: [
          { required: true, message: '任务ID，冗余便于查询'+this.$t('不能为空'), trigger: 'blur' }
        ],
        orderId: [
          { required: true, message: '订单ID，外键订单表'+this.$t('不能为空'), trigger: 'blur' }
        ],
        orderNo: [
          { required: true, message: '订单号'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        submitId: null,
        taskId: null,
        orderId: null,
        orderNo: null,
        proofImages: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskSubmitOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateTaskSubmitOrder(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addTaskSubmitOrder(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
